import { Pagination } from './common-model'
import { MultiStop, Order } from './marketplace-service-model'

export interface OrderAssignmentsResponse {
  orderAssignments: Array<OrderAssignmentEntity>
  pagination: Pagination
  filters: OrderAssignmentFiltersRequest
}

export interface OrderAssignmentEntity {
  orderAssignment: OrderAssignment
  order: Partial<Order>
  multiStop: Partial<MultiStop>
}

export interface OrderAssignment {
  id: number
  state: OrderAssignmentState
  price: number
  validUntil: string
  created: string
  modified: string
}

export enum OrderAssignmentState {
  All = 'all',
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Expired = 'EXPIRED',
  Cancelled = 'CANCELLED'
}

export interface OrderAssignmentFiltersRequest {
  size: string
  page: string
  sort: FilterSort
  state: OrderAssignmentState
  reference: string
  pickup_range_start: string
  pickup_range_end: string
  pickup_country: string
  pickup_address: string
  drop_off_country: string
  drop_off_address: string
  after: string
  pickup_place_id: string
  pickup_location_name: string
  drop_off_place_id: string
  drop_off_location_name: string
  radius: string
  progress: OrderAssignmentState
}

export type FilterSort = 'newest' | 'oldest'
